import { configureStore,combineReducers } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import propertyInfoReducer from "./propertyInfoSlice";
import sessionControlReducer from './sessionControl';
import propertyReducer from "./propertySlice";
import propertyUnitReducer from "./propertyUnitSlice";
import houseUnitReducer from "./houseUnitSlice";
import forgotPasswordReducer from './forgotPasswordSlice';
import bitrixRefreshPageReducer from './bitrixRefreshPage';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from "redux-thunk";

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['userSessionControl','forgotPassword', 'user','refreshPageBitrix'], // Adicione o reducer que será persistido
};

const rootReducer = combineReducers({
  user: userReducer,
  propertyInfo: propertyInfoReducer,
  userSessionControl: sessionControlReducer,
  property: propertyReducer,
  propertyUnit: propertyUnitReducer,
  houseUnit: houseUnitReducer,
  forgotPassword: forgotPasswordReducer,
  refreshPageBitrix: bitrixRefreshPageReducer ,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});



export default store;


